module.exports = __webpack_public_path__ + "static/media/batches-large.66e7742e.jpg";